import { Injectable } from '@angular/core';
import { Article, HierarchicalCategory } from '../../../../catalog';
import { ItemInterface } from '../models/ecommerce/item.interface';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagManagerHelper {
  public static readonly ITEM_MAX_CATEGORIES: number = 5;

  public static hierarchicalCategoriesToItemCategories(hierCat: HierarchicalCategory[] = []): Partial<ItemInterface> {
    const itemPartial: Partial<ItemInterface> = {};
    return hierCat
      .map((cat: HierarchicalCategory, index: number): Partial<ItemInterface> => {
        if (index >= GoogleTagManagerHelper.ITEM_MAX_CATEGORIES) {
          return {};
        }

        return { [`item_category${index === 0 ? '' : index + 1}`]: cat.sValue };
      })
      .reduce(
        (obj: Partial<ItemInterface>, item: Partial<ItemInterface>) => ({
          ...obj,
          ...item,
        }),
        itemPartial,
      );
  }

  public static articleToItem(article: Article): ItemInterface {
    return {
      item_id: article.sArticleID.toString(),
      item_name: article.sName,
      currency: article.oPriceInfo?.sCurrencyCode,
      price: GoogleTagManagerHelper.articlePrice(article),
      discount: article.oPriceInfo?.decSpecialPriceNet ? article.oPriceInfo?.decBasePriceNet - article.oPriceInfo?.decSpecialPriceNet : 0,
      ...GoogleTagManagerHelper.hierarchicalCategoriesToItemCategories(
        article.oProductInfo?.length ? article.oProductInfo[0].listHierarchicalCategories : [],
      ),
    };
  }

  public static articlePrice(article: Article): number {
    return article.oPriceInfo?.decSpecialPriceNet || article.oPriceInfo?.decBasePriceNet;
  }
}
